type Props = {
    status?: string;
};

const STATUS_CONFIG: Record<string, { text: string; dot: string }> = {
    SENT: {
        text: "bg-slate-50 text-slate-700 ring-slate-200",
        dot: "bg-slate-400",
    },
    DELIVERED: {
        text: "bg-emerald-50 text-emerald-700 ring-emerald-200",
        dot: "bg-emerald-500",
    },
    READ: {
        text: "bg-blue-50 text-blue-700 ring-blue-200",
        dot: "bg-blue-500",
    },
    FAILED: {
        text: "bg-red-50 text-red-700 ring-red-200",
        dot: "bg-red-500",
    },
    PENDING: {
        text: "bg-amber-50 text-amber-700 ring-amber-200",
        dot: "bg-amber-500",
    },
};

export function StatusShow({ status }: Props) {
    const normalizedStatus = status?.trim().toUpperCase() || "";
    
    const config = STATUS_CONFIG[normalizedStatus] || {
      text: "bg-slate-50 text-slate-600 ring-slate-200",
      dot: "bg-slate-400",
    };

    return (
        <span
            className={`inline-flex items-center gap-1.5 text-[11.5px] font-semibold tracking-wide px-2.5 py-1 rounded-full ring-1 ring-inset ${config.text}`}
        >
            <span
                className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`}
            />
            {status || "UNKNOWN"}
        </span>
    );
}